import { render } from "./SiteServicesView.vue?vue&type=template&id=2890baa5"
import script from "./SiteServicesView.vue?vue&type=script&lang=js"
export * from "./SiteServicesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__